<script>
const typeFormat = { day: "DD/MM/YYYY", month: "MM/YYYY", year: "YYYY" };

export default {
  name: "s-datetimepicker",

  template: '<input style="width: 150px; text-align: center">',

  props: {
    value: String,
    type: {
      type: String,
      default: "date",
    },
    showOn: {
      type: String,
      default: "button",
    },
    timeFormat: {
      type: String,
      default: "HH:mm",
    },
    stepMinute: {
      type: Number,
      default: 1,
    },
    stepSecond: {
      type: Number,
      default: 1,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    componentName() {
      return this.getComponentName(this.type);
    },
  },

  watch: {
    value(novo) {
      jQuery(this.$el).val(novo);
    },
    disabled(v) {
      this.setDisabled(v);
    },
    type(newType, oldType) {
      this.remakeComponent(newType, oldType);
    },
  },

  beforeDestroy() {
    jQuery(this.$el)[this.componentName]("destroy");
  },

  methods: {
    getComponentName(type) {
      return {
        date: "datepicker",
        datetime: "datetimepicker",
        day: "datepickerDay",
        week: "datepickerWeek",
        month: "datepickerMonth",
        year: "datepickerYear",
        time: "timepicker",
      }[type] || "datetimepicker";
    },
    setDisabled(v) {
      jQuery(this.$el)[this.componentName]("disable", v);
    },
    remakeComponent(newType, oldType) {
      const $el = jQuery(this.$el);

      oldType && $el[this.getComponentName(oldType)]("destroy");
      this.make();

      const date = newType === "week"
        ? $el.datepickerWeek("getDateWeek", new Date())
        : moment().format(typeFormat[newType] || "DD/MM/YYYY");

      $el.val(date);
      this.$emit("input", date);
    },
    make() {
      const $el = jQuery(this.$el);

      if (["month", "date", "day", "week", "year"].includes(this.type)) {
        $el[this.componentName]({
          showOn: this.showOn,
          onClose: () => this.$emit("input", $el.val()),
        });
      } else {
        $el[this.componentName]({
          timeFormat: this.timeFormat,
          stepMinute: this.stepMinute,
          stepSecond: this.stepSecond,
          showOn: this.showOn,
        });
      }

      this.disabled && this.setDisabled(true);
      $el.on("change", () => this.$emit("input", $el.val()));
      $el.val(this.value);
    },
  },

  mounted() {
    this.make();
  },
};
</script>